export default __webpack_public_path__ + "web/react/components/app-download-promo/background.3421dc97fa722b88c370c4339e1dfc37.mp4";